(function(){
 if(window.__buildoraAurora){window.__buildoraAurora.scan();return;}
 var instances=new Map();
 function init(bar){
  if(instances.has(bar))return;
  var scope=bar.closest('.buildora-product-page,[data-aurora-page]')||bar.closest('main')||document.body;
  var frame=0,disposed=false;
  function target(){
   var heroes=Array.from(scope.querySelectorAll('.pl-hero[data-pl-aurora-revision="2"]')).filter(function(hero){return !bar.dataset.auroraProduct||hero.dataset.auroraProduct===bar.dataset.auroraProduct;});
   var before=heroes.filter(function(hero){return !!(hero.compareDocumentPosition(bar)&Node.DOCUMENT_POSITION_FOLLOWING);});
   var hero=before[before.length-1]||(heroes.length===1?heroes[0]:null);
   return hero&&hero.querySelector('.pl-buy .pl-cta');
  }
  function available(button){return button&&button.isConnected&&!button.disabled&&button.getAttribute('aria-disabled')!=='true'&&button.getClientRects().length&&getComputedStyle(button).visibility!=='hidden';}
  function visible(show){bar.inert=!show;bar.setAttribute('aria-hidden',String(!show));bar.classList.toggle('au-visible',!!show);}
  function update(){frame=0;if(disposed)return;var button=target();visible(available(button)&&button.getBoundingClientRect().bottom<=0);}
  function schedule(){if(!frame&&!disposed)frame=requestAnimationFrame(update);}
  function click(event){
   if(!event.target.closest('.pl-stcta'))return;
   event.preventDefault();event.stopImmediatePropagation();
   var button=target();if(!available(button))return;
   button.scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
   button.focus({preventScroll:true});schedule();
  }
  var observer=new MutationObserver(schedule);
  observer.observe(scope,{childList:true,subtree:true,attributes:true,attributeFilter:['disabled','aria-disabled','hidden']});
  window.addEventListener('scroll',schedule,{passive:true});window.addEventListener('resize',schedule);bar.addEventListener('click',click,true);
  instances.set(bar,function(){disposed=true;cancelAnimationFrame(frame);observer.disconnect();window.removeEventListener('scroll',schedule);window.removeEventListener('resize',schedule);bar.removeEventListener('click',click,true);visible(false);instances.delete(bar);});
  update();
 }
 function scan(){instances.forEach(function(dispose,bar){if(!bar.isConnected)dispose();});document.querySelectorAll('[data-aurora-sticky]').forEach(init);}
 window.__buildoraAurora={scan:scan};
 document.addEventListener('shopify:section:load',scan);
 document.addEventListener('shopify:section:unload',function(event){instances.forEach(function(dispose,bar){if(bar===event.target||event.target.contains(bar))dispose();});});
 scan();
})();